import {
    createUrlTileCodec,
    createUrlTileDefinition,
    type UrlTileModule,
    type UrlTileRenderContext,
    urlTileStringCodec,
} from '../url-tiles';
import { GoalDetailTile } from './goal-detail/GoalDetailTile';
import { NewGoalTile } from './new-goal/NewGoalTile';
import {
    createGrowthGoalTilePayload,
    GROWTH_GOAL_TILE_TYPE,
    GROWTH_NEW_GOAL_TILE_TYPE,
    GROWTH_TILE_SLOT_KEY,
    type GrowthGoalTilePayload,
    type GrowthNewGoalTilePayload,
    growthGoalTileSchema,
    growthNewGoalTileSchema,
} from './tile-payloads';

const GROWTH_TILE_WIDTH = '560px';

type GrowthGoalTileProps = {
    readonly context: UrlTileRenderContext;
    readonly payload: GrowthGoalTilePayload;
};

type GrowthNewGoalTileProps = {
    readonly context: UrlTileRenderContext;
    readonly payload: GrowthNewGoalTilePayload;
};

const growthGoalUrlTileDefinition = createUrlTileDefinition({
    codec: createUrlTileCodec<GrowthGoalTilePayload>({ segments: ['goalId'], type: GROWTH_GOAL_TILE_TYPE }),
    maxWidth: GROWTH_TILE_WIDTH,
    minWidth: GROWTH_TILE_WIDTH,
    render: ({ context, payload }: GrowthGoalTileProps) => (
        <GoalDetailTile goalId={payload.goalId} onClose={() => context.closeTile(GROWTH_TILE_SLOT_KEY)} />
    ),
    schema: growthGoalTileSchema,
    slotKey: () => GROWTH_TILE_SLOT_KEY,
    tileKey: (payload) => `${GROWTH_TILE_SLOT_KEY}.${payload.goalId}`,
    toProps: (payload, context): GrowthGoalTileProps => ({ context, payload }),
});

const growthNewGoalUrlTileDefinition = createUrlTileDefinition({
    codec: createUrlTileCodec<GrowthNewGoalTilePayload>({
        options: [{ codec: urlTileStringCodec, field: 'recommendationId', key: 'rec' }],
        segments: [],
        type: GROWTH_NEW_GOAL_TILE_TYPE,
    }),
    maxWidth: GROWTH_TILE_WIDTH,
    minWidth: GROWTH_TILE_WIDTH,
    render: ({ context, payload }: GrowthNewGoalTileProps) => (
        <NewGoalTile
            recommendationId={payload.recommendationId}
            onClose={() => context.closeTile(GROWTH_TILE_SLOT_KEY)}
            onCreated={(goalId) => context.updateTile(createGrowthGoalTilePayload(goalId))}
        />
    ),
    schema: growthNewGoalTileSchema,
    slotKey: () => GROWTH_TILE_SLOT_KEY,
    tileKey: (payload) => `${payload.type}.${payload.recommendationId ?? 'blank'}`,
    toProps: (payload, context): GrowthNewGoalTileProps => ({ context, payload }),
});

export const growthUrlTileModule: UrlTileModule = {
    definitions: [growthGoalUrlTileDefinition, growthNewGoalUrlTileDefinition],
};
